import smartSolveApi from './instances/smartsolve';

export const performRoleActorsAction = async ({ roleId, users, actionType }) => {
  try {
    const response = await smartSolveApi.post(`/roles/${roleId}/users`, { users, actionType });

    return response.data;
  } catch (e) {
    throw new Error(`performRoleActorsAction() failed: ${e}`);
  }
};
